<template>
    <div class="w100 Contenido">

      <Titulo :seccion="Herramientas.PerspectivasClimaticas.title" icon="cloud-sun"/>
      <Descripcion>
        {{ Herramientas.PerspectivasClimaticas.description }}
      </Descripcion>

      <div id="links">
         <a href="https://www.agroideassa.com.ar/img/Cordoba-marzo22.pdf" target="_blank" class="BotonVerMapa">Córdoba</a>
         <a href="https://www.agroideassa.com.ar/img/SantaFe-marzo22.pdf" target="_blank" class="BotonVerMapa">Santa Fe</a>
      </div>
    </div>
</template>

<script>
// TODO:(!) meter en mixing
import { Herramientas } from "../../Auxiliares/Enums";

export default {
  data() {
    return {
      Herramientas
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../Css/Componentes.scss";
@import "../../Css/Globales.css";

  #links {
    margin-top: 35px;
  }
  #links a {
    margin: 15px;
    padding: 10px;
    font-size: 18px;
  }
</style>
